import styled from 'styled-components'

export const CardItem = styled.div`
  background: #f3f4f6;
  border-radius: 15px;     
  width: 295px;           
  height: 500px;          
  display: flex;
  flex-direction: column; 
  gap: 10px;               
`

export const CardHeader = styled.div`
  background: #ffffff;
  display: flex;
  align-items: center;        
  gap: 16px;
  padding: 24px;
  min-height: 104px;         
`

export const CardBody = styled.div`

  background: #ffffff;
  padding: 0 24px 0 24px;
`

export const RoundImage = styled.div`
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const Heading = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0;
  color: #111827;
`

export const SubHeading = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0;
  color: #6b7280;
`

export const ListItem = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0;
  color: #374151;
`

export const ButtonStyle = styled.div`
  position: absolute;
  right: 24px;
  bottom: 24px;
`

export const CardTop = styled.div`
  padding-bottom: 24px;
  border-radius: 0 0 15px 15px;
  background: #ffffff;
`

export const CardStats = styled.div`
  background: #f3f4f6;
  padding: 16px 24px;
  margin-top: 12px;
  border-radius: 0 0 15px 15px;
`

export const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0;
  color: #374151;
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }

  span {
    font-weight: 400;
  }

  b {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0;
    color: #111827;
  }
`